import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProofSection() {
  return <section className="py-16 px-6" data-id="element-221">
      <div className="max-w-3xl mx-auto" data-id="element-222">
        <FadeIn data-id="element-223">
          <div className="relative p-8 md:p-12 bg-sage/10 rounded-3xl overflow-hidden" data-id="element-224">
            {/* Decorative quote mark */}
            <div className="absolute -top-4 -left-2 text-[120px] font-playfair text-sage/20 leading-none select-none pointer-events-none" data-id="element-225">
              "
            </div>

            <div className="relative z-10" data-id="element-226">
              <h3 className="text-2xl md:text-3xl font-bold text-charcoal mb-6 text-center md:text-left" data-id="element-227">
                La ciencia detrás del resultado
              </h3>
              <p className="text-lg md:text-xl text-charcoal/80 leading-relaxed font-playfair italic" data-id="element-228">
                Al vaciar los depósitos de glucógeno (donde cada gramo retiene
                4g de agua), es físicamente posible reducir entre 1 y 3 cm de
                volumen abdominal de forma real y visible antes de que termine
                el fin de semana.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}